define('helper-state-getProps',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        if (!state || !state.entity || !state.entity.props) {
            return {};
        }

        return state.entity.props.constructor === Object ? state.entity.props : {};
    };
});
